var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTalkToExpertNavBarClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#D4DDFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8529 23.6835C22.8529 26.3757 20.6943 28.5345 18.0001 28.5345C15.3068 28.5345 13.1473 26.3757 13.1473 23.6835C13.1473 20.9912 15.3068 18.8333 18.0001 18.8333C20.6943 18.8333 22.8529 20.9912 22.8529 23.6835ZM18.0001 37.1667C14.0239 37.1667 10.6667 36.5204 10.6667 34.0271C10.6667 31.5328 14.045 30.9094 18.0001 30.9094C21.9772 30.9094 25.3334 31.5557 25.3334 34.0491C25.3334 36.5433 21.9551 37.1667 18.0001 37.1667Z",
    fill: "#2653F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 11H30.75M23.25 14H26.25M27 20L24 17H21.75C20.9216 17 20.25 16.3284 20.25 15.5V9.5C20.25 8.67157 20.9216 8 21.75 8H32.25C33.0784 8 33.75 8.67157 33.75 9.5V15.5C33.75 16.3284 33.0784 17 32.25 17H30L27 20Z",
    stroke: "#2653F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkToExpertNavBarClosed);
export default __webpack_public_path__ + "static/media/talkToExpertNavBarClosed.f0d5d1cd4fd164120a87a793be822c21.svg";
export { ForwardRef as ReactComponent };